// extracted by mini-css-extract-plugin
export default {"administrationPageContainer":"SettingsAdministrationPage_administrationPageContainer__Xh3+n","administrationContainer":"SettingsAdministrationPage_administrationContainer__FH0pt"};